function ModalContent({
    children,
    className = '',
    spacing = 'normal',
    scroll = false,
}) {
    const spacingClasses = {
        compact: 'px-5 py-[18px]',
        normal: 'px-[22px] py-5',
        roomy: 'px-6 py-6',
    }

    return (
        <div
            className={`text-left text-sm text-olm-gray ${
                spacingClasses[spacing] || spacingClasses.normal
            } ${scroll ? 'max-h-[70vh] overflow-y-auto' : ''} ${className}`}>
            {children}
        </div>
    )
}

export default ModalContent
